import React from 'react';
import { XIcon } from "../../assets/Icons";
import styled from "styled-components";

const SpecInfoList = ({ specInfo,onClose, onCheckedElement, checkedList }) => {
    return (
        <>
            {specInfo.map(item => { // 상세제원
                const {name,child} = item
                return (
                    <>
                        <h3>{name}</h3>
                        <ItemXButton onClick={onClose} >
                            <XIcon/>
                        </ItemXButton>
                        <InfoLabelWrapper>
                            {child?.map(v => {
                                return(
                                    <label htmlFor={'info-' + v.spec_name_idx}>
                                        <InfoCheckBox
                                            type="checkbox"
                                            id={'info-' + v.spec_name_idx}
                                            name="spec_info"
                                            value={v.spec_name_idx}
                                            checked={checkedList.includes(String(v.spec_name_idx))}
                                            onChange={e => {
                                                onCheckedElement(e.target.checked, e.target.value);
                                            }}
                                        />
                                            <span className="info_name">{v.name}</span>
                                    </label>
                                )
                            })}
                        </InfoLabelWrapper>
                    </>
                )
            })}
        </>
    );
};

export default SpecInfoList;


const InfoCheckBox = styled.input`
    border: 1px solid #999999;
    width: 20px !important;
    height: 20px !important;
    z-index: 200;

    &:hover {
        color:#418DED;
    }
`

const ItemXButton = styled.button`
    border: none;
    background-color: transparent;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 20;

    &:hover {
        path {
            stroke: #3281ED;
        }
    }
`
const InfoLabelWrapper = styled.div`
    display: grid;
    grid-template-columns: 133px 133px 133px;
    grid-row-gap: 8px;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/compareview/specInfoList.js